export default "__VITE_ASSET__3PSIfQTw__"